module.exports = "https://chowbus-web-static.chowbus.com/_next/static/images/download_demo_take5-2ad3b05c8cdafb5722fc1f64ef022653.png";